import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form, Badge } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Preloader from "../../Components/Preloader";
import { getLiveTracking } from "../../redux/actions/MapActions";
import LeafletMapAllVehicle from "../../Components/LeafletMapAllVehicle";
import GoogleMapAllVehicle from "../../Components/GoogleMapAllVehicle";
import Select from "react-dropdown-select";
import { getMasterUsertypeUserWiseList, getMasterUserUserTypeWiseList } from "../../redux/actions/MasterActions";
import useDebounce from "../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from "../../util/generalUtills";
import FeatherIcon from "feather-icons-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faBatteryEmpty, 
  faBatteryQuarter, 
  faBatteryHalf, 
  faBatteryThreeQuarters, 
  faBatteryFull,
  faChargingStation
} from "@fortawesome/free-solid-svg-icons";
import Battery0BarIcon from "@mui/icons-material/Battery0Bar";
import Battery20Icon from "@mui/icons-material/Battery20";
import Battery50Icon from "@mui/icons-material/Battery50";
import Battery80Icon from "@mui/icons-material/Battery80";
import BatteryFullIcon from "@mui/icons-material/BatteryFull";
import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull";


const LiveTrack = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(10);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const [sortBy, setSortBy] = useState('name'); // 'name', 'status', 'battery', 'time'
  const [localSearch, setLocalSearch] = useState(""); // Local search for card list
  const [selectedVehicleId, setSelectedVehicleId] = useState(null); // Selected vehicle for map
  const [formData, setFormData] = useState({
    lat:0.00,
    lng:0.00
  });
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    mapReducer:{
      liveTrackingData,
      vehicleCount,
      liveTrackingPermissionData,
      loadingMap,
      errorsMap,
    },
  } = useSelector((state) => state);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };
  
  // useEffect(() => {
  //   // Function to fetch live tracking data
  //   const fetchLiveTracking = () => {
  //     dispatch(getLiveTracking(auth.token,1000,1,"","ASC"));
  //   };
  
  //   // Initial fetch
  //   fetchLiveTracking();
  
  //   // Set an interval to fetch data every 30 seconds
  //   const intervalId = setInterval(() => {
  //     // fetchLiveTracking();
  //   }, 30000); // 30,000 milliseconds = 30 seconds
  
  //   // Clean up the interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, [auth, dispatch]);

  const fetchMapList = useCallback(() => {
    if (auth?.token) {
      dispatch(getLiveTracking(auth.token, paginate, page, search, sort));
    }
  }, [auth, paginate, page, search, sort, dispatch]);

  useDebounce(fetchMapList, 500, [auth, paginate, page, search, sort]);
  

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(()=>{
    console.log('liveTrackingData',liveTrackingData);
  },[liveTrackingData])

  useEffect(() => {
      document.title = `Live Tracking :: ${auth?.generalSettings?.title}`;
    }, []);


  const getBatteryIcon = (batteryLevel) => {
    if (batteryLevel === 100) return faBatteryFull;
    if (batteryLevel >= 75) return faBatteryThreeQuarters;
    if (batteryLevel >= 50) return faBatteryHalf;
    if (batteryLevel >= 25) return faBatteryQuarter;
    return faBatteryEmpty;
  };

  const getBatteryColor = (batteryLevel) => {
    if (batteryLevel >= 75) return "green";
    if (batteryLevel >= 25) return "orange";
    return "red";
  };

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Live Tracking"), path: "/Live-Tracking", active: true },
        ]}
        title={t("Live Tracking")}
      />
      <Row>
        <Col lg={9}>
          <Card>
            <Card.Body>
              {/* <div className="mb-2">
                <Row>
                  <Col lg={3}>
                    <div className="d-flex align-items-center">
                    {(liveTrackingPermissionData.filter ) && (<>
                      <input
                        type="search"
                        placeholder="Search..."
                        className="form-control ms-1"
                        autoComplete="off"
                        value={search}
                        onChange={handleSearchChange}
                      />
                      </>)}
                      
                    </div>
                  </Col>
                </Row>
              </div> */}
              <div style={{ position: "relative", overflow: "hidden", height: "600px" }}>
                {selectedVehicleId && (
                  <div className="position-absolute top-0 start-0 m-2" style={{zIndex: 1000}}>
                    <Button 
                      size="sm" 
                      variant="danger"
                      onClick={() => setSelectedVehicleId(null)}
                      style={{fontSize: '11px', padding: '2px 8px'}}
                    >
                      <FeatherIcon icon="x" size={12} className="me-1" />
                      Clear Selection
                    </Button>
                  </div>
                )}
                <GoogleMapAllVehicle
                  mapHeight={"600px"}
                  vehicleData={selectedVehicleId 
                    ? liveTrackingData.filter(v => v.id === selectedVehicleId)
                    : liveTrackingData
                  }
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={3}>
          <Card>
            <Card.Body>
              <div className="mb-2 d-flex gap-1 align-items-center">
                <input
                  type="search"
                  placeholder="Search..."
                  className="form-control form-control-sm"
                  style={{flex: 1, fontSize: '11px', padding: '2px 8px'}}
                  autoComplete="off"
                  value={localSearch}
                  onChange={(e) => setLocalSearch(e.target.value)}
                />
                <Form.Select 
                  size="sm" 
                  style={{width: '120px', fontSize: '11px', padding: '2px 8px'}}
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                >
                  <option value="name">Name</option>
                  <option value="status">Status</option>
                  <option value="battery">Battery</option>
                  <option value="time">Time</option>
                </Form.Select>
                <Button 
                  size="sm" 
                  variant="outline-secondary"
                  style={{padding: '2px 8px', fontSize: '11px'}}
                  onClick={() => setSort(sort === 'asc' ? 'desc' : 'asc')}
                >
                  <FeatherIcon icon={sort === 'asc' ? 'arrow-up' : 'arrow-down'} size={12} />
                </Button>
              </div>
              <div style={{overflowY:'auto',maxHeight:'560px'}}>
                {(() => {
                  const filteredData = liveTrackingData?.filter((item) => {
                    if (!localSearch) return true;
                    const searchLower = localSearch.toLowerCase();
                    return (
                      (item?.name || '').toLowerCase().includes(searchLower) ||
                      (item?.phone || '').toLowerCase().includes(searchLower) ||
                      (item?.address || '').toLowerCase().includes(searchLower) ||
                      (item?.adminUserType?.name || '').toLowerCase().includes(searchLower) ||
                      (item?.citiesAdminUsers?.city_name || '').toLowerCase().includes(searchLower) ||
                      (item?.activity_type || '').toLowerCase().includes(searchLower)
                    );
                  });
                  
                  return filteredData.length === 0 ? (
                    <div className="text-center py-3">
                      <p className="text-muted mb-0" style={{fontSize: '12px'}}>
                        {liveTrackingData.length === 0 ? 'No data found' : 'No results found'}
                      </p>
                    </div>
                  ) : (
                    <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
                      {filteredData
                      ?.sort((a, b) => {
                        let aVal, bVal;
                        switch(sortBy) {
                          case 'name':
                            aVal = a?.name || '';
                            bVal = b?.name || '';
                            return sort === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
                          case 'status':
                            aVal = a?.activity_type || '';
                            bVal = b?.activity_type || '';
                            return sort === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
                          case 'battery':
                            aVal = parseInt(a?.level) || 0;
                            bVal = parseInt(b?.level) || 0;
                            return sort === 'asc' ? aVal - bVal : bVal - aVal;
                          case 'time':
                            aVal = new Date(a?.lastLocation || 0).getTime();
                            bVal = new Date(b?.lastLocation || 0).getTime();
                            return sort === 'asc' ? aVal - bVal : bVal - aVal;
                          default:
                            return 0;
                        }
                      })
                      ?.map?.((item, index) => {
                        const isSelected = selectedVehicleId === item.id;
                        return (
                          <div key={item.id} style={{width: '100%'}}>
                            <Card 
                              className="h-120" 
                              style={{
                                border: isSelected ? '2px solid #0d6efd' : '1px solid #dee2e6', 
                                fontSize: '11px',
                                cursor: 'pointer',
                                backgroundColor: isSelected ? '#f0f7ff' : 'white',
                                transition: 'all 0.2s'
                              }}
                              onClick={() => setSelectedVehicleId(isSelected ? null : item.id)}
                            >
                              <Card.Body className="p-2" style={{position: 'relative'}}>
                                <Badge 
                                  bg="primary" 
                                  style={{
                                    position: 'absolute',
                                    top: '4px',
                                    right: '4px',
                                    fontSize: '9px',
                                    padding: '2px 6px',
                                    zIndex: 10
                                  }}
                                >
                                  #{index + 1}
                                </Badge>
                                <div className="d-flex justify-content-between align-items-center" style={{marginBottom: '4px'}}>
                                  <div className="flex-grow-1" style={{minWidth: 0}}>
                                    <div className="d-flex align-items-center gap-1">
                                      <div className="fw-bold text-truncate" style={{fontSize: '12px'}} title={item?.name}>
                                        {item?.name || 'N/A'}
                                      </div>
                                      {isSelected && (
                                        <FeatherIcon icon="map-pin" size={14} className="text-primary" />
                                      )}
                                    </div>
                                    <div className="text-muted text-truncate" style={{fontSize: '10px'}}>
                                      <FeatherIcon icon="phone" size={10} className="me-1" />
                                      {item?.phone || 'N/A'}
                                    </div>
                                    {item?.address && (
                                      <div className="text-muted text-truncate" style={{fontSize: '9px'}} title={item?.address}>
                                        <FeatherIcon icon="home" size={9} className="me-1" />
                                        {item?.address}
                                      </div>
                                    )}
                                  </div>
                                  <FontAwesomeIcon
                                    icon={item?.is_charging === true ? faChargingStation : getBatteryIcon(parseInt(item?.level || 0))}
                                    style={{ fontSize: "24px", color: getBatteryColor(parseInt(item?.level || 0)), flexShrink: 0 }}
                                  />
                                </div>
                                
                                <div className="d-flex align-items-center gap-1" style={{marginBottom: '4px'}}>
                                  {item?.activity_type === "still" ? 
                                    <FeatherIcon icon="activity" size={14} className="text-warning" />
                                  : (
                                    <Badge className="bg-success" style={{fontSize: '8px', padding: '2px 4px'}}>
                                      {item?.activity_type}
                                    </Badge>
                                  )}
                                  {item?.is_charging === true ? 
                                    <FeatherIcon icon="battery-charging" size={14} className="text-primary" />
                                  : (
                                    <FeatherIcon icon="battery" size={14} className="text-muted" />
                                  )}
                                  {item?.adminUserType?.name && (
                                    <Badge bg="secondary" style={{fontSize: '8px', padding: '2px 4px'}}>
                                      <FeatherIcon icon="user" size={8} className="me-1" />
                                      {item?.adminUserType?.name}
                                    </Badge>
                                  )}
                                  {item?.citiesAdminUsers?.city_name && (
                                    <Badge bg="info" style={{fontSize: '8px', padding: '2px 4px'}}>
                                      <FeatherIcon icon="map-pin" size={8} className="me-1" />
                                      {item?.citiesAdminUsers?.city_name}
                                    </Badge>
                                  )}
                                </div>

                                <div className="d-flex align-items-center text-muted" style={{fontSize: '9px', marginTop: '2px'}}>
                                  <FeatherIcon icon="clock" size={10} className="me-1" />
                                  <span className="text-truncate">
                                    {getDisplayDateTimeFormat(item?.lastLocation)}
                                  </span>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                        );
                      })
                    }
                    </div>
                  );
                })()}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingMap && (<Preloader/>)}
    </>
  );
};

export default LiveTrack;